import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <p>&nbsp;</p>
  </footer>
)

export default Footer
